import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { Home, Map } from "lucide-vue-next";

  type ViewType =
    | "hero"
    | "browse"
    | "detail"
    | "eoi"
    | "eoi-success"
    | "map"
    | "resources";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerBottomNavigation',
  props: {
    currentView: {},
    onNavigate: { type: Function },
    showHomeDesigns: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const showHomeDesigns = computed(() => props.showHomeDesigns !== false);

  const isHomeActive = computed(() =>
    ["browse", "detail", "eoi", "eoi-success"].includes(props.currentView)
  );
  const isMapActive = computed(() => props.currentView === "map");

const __returned__ = { props, showHomeDesigns, isHomeActive, isMapActive, computed, get Home() { return Home }, get Map() { return Map } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})